import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import About from './components/About/About';
import Skills from './components/Skills/Skills';
import Portfolio from './components/Portfolio/Portfolio';
import Experience from './components/Experience/Experience';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import './App.css';
import './locales';

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Person',
  name: 'Mariano Ventura',
  jobTitle: 'Full Stack Developer',
  url: 'https://marianoventura.dev',
  sameAs: [
    'https://github.com/mvc2511',
    'https://www.linkedin.com/in/mvc251/',
    'https://www.instagram.com/bit.mvc/'
  ],
  knowsAbout: ['React', '.NET', 'React Native', 'AWS', 'Angular', 'Node.js', 'SQL'],
  email: 'marianov2511@gmail.com'
};

function App() {
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
    document.querySelector('meta[name="theme-color"]').setAttribute(
      'content',
      theme === 'dark' ? '#080b12' : '#ffffff'
    );
  }, [theme]);

  const toggleTheme = () => {
    setTheme(theme === 'light' ? 'dark' : 'light');
  };

  return (
    <div className="App">
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      </Helmet>
      <a href="#main-content" className="skip-link">Skip to content</a>
      <Header toggleTheme={toggleTheme} theme={theme} />
      <main id="main-content">
        <Hero />
        <About />
        <Skills />
        <Portfolio />
        <Experience />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;